document.addEventListener("DOMContentLoaded", function () {
  menuHoverEvent();
});

 
 var swiper;

  function initSwiper() {
    var screenWidth = window.innerWidth;

    if (screenWidth >= 990) {
      if (!swiper) {
        swiper = new Swiper(".products-grid-slider", {
          slidesPerView: 4,
          spaceBetween: 20,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
          },
        });
      }
    } else {
      if (swiper) {
        swiper.destroy(true, true);
        swiper = null;
      }
    }
  }

  initSwiper();
  window.addEventListener("resize", initSwiper);


  // Accordion section

  const accordionTitles = document.querySelectorAll(".accordion-box-wrap .accordion-title");
  const allPanels = document.querySelectorAll(".accordion-box-wrap .panel");
  
  if (accordionTitles.length > 0 && allPanels.length > 0) {
    // Open the first accordion by default
    accordionTitles[0].classList.add("active");
    allPanels[0].style.maxHeight = allPanels[0].scrollHeight + "px";
  
    accordionTitles.forEach(title => {
      title.addEventListener("click", function () {
        const panel = this.nextElementSibling;
        if (!panel || !panel.classList.contains("panel")) return;
  
        // Close other panels
        allPanels.forEach(p => {
          if (p !== panel) {
            p.style.maxHeight = null;
          }
        });
  
        // Remove 'active' class from other titles
        accordionTitles.forEach(t => {
          if (t !== this) {
            t.classList.remove("active");
          }
        });
  
        // Toggle active class and open/close panel
        this.classList.toggle("active");
  
        if (panel.style.maxHeight) {
          panel.style.maxHeight = null;
        } else {
          panel.style.maxHeight = panel.scrollHeight + "px";
        }
      });
    });
  }

  function updateArrowPosition() {
    const media = document.querySelector(".swiper-slide .card__media img");

    if (!media) return;

    const imageHeight = media.clientHeight;
    const arrows = document.querySelectorAll(".swiper-button-arrow");

    arrows.forEach(arrow => {
      arrow.style.top = (imageHeight / 2) + "px"; // center of image
    });
  }

  updateArrowPosition();
  window.addEventListener("resize", updateArrowPosition);


document.addEventListener("shopify:section:load", function (event) {
  initSwiper();
});

document.addEventListener("shopify:section:unload", function () {
  if (swiper) {
    swiper.destroy(true, true);
    swiper = null;
  }
});



function menuHoverEvent() {
  const headerMenuLists = document.querySelectorAll('header-menu > details');
  if(headerMenuLists.length){
    headerMenuLists.forEach(list => {
      //on hover
      list.addEventListener("mouseenter", (e) => {
        e.target.setAttribute('open','');
        if(e.target.querySelector('summary')){
          e.target.querySelector('summary').setAttribute('aria-expanded','true');
        }
      });
      //on hover out
      list.addEventListener("mouseleave", (e) => {
        headerMenuLists.forEach(list => {
          list.removeAttribute('open');
          if(list.querySelector('summary')){
            list.querySelector('summary').setAttribute('aria-expanded','false');
          }
        });
      });
    });
  }
}
